//@flow

import {colors} from '../../../assets/styles/colors';
import type {ChatServiceType} from '../../../entities';

export const SERVICES_COLORS = {
  facebookMessenger: '#3b5998',
  instagram: '#e4405f',
  whatsapp: '#25d366',
};

export const SERVICES_GRADIENTS = {
  facebookMessenger:
    'linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)',
  instagram: 'linear-gradient(90deg, #bc4e9c 0%, #f80759 100%)',

  whatsapp: 'linear-gradient(90deg, #2ad168 0%, #2ad168 100%)',
};

export function getServiceColor(service: ChatServiceType) {
  if (service === 'FB_MESSENGER') {
    return SERVICES_COLORS.facebookMessenger;
  }
  if (service === 'INSTAGRAM') {
    return SERVICES_COLORS.instagram;
  }
  if (service === 'WHATSAPP_WEB') {
    return SERVICES_COLORS.whatsapp;
  }
  return colors.primary;
}

export function getServiceGradient(service?: ChatServiceType) {
  if (service === 'FB_MESSENGER') {
    return SERVICES_GRADIENTS.facebookMessenger;
  }
  if (service === 'INSTAGRAM') {
    return SERVICES_GRADIENTS.instagram;
  }
  if (service === 'WHATSAPP_WEB') {
    return SERVICES_GRADIENTS.whatsapp;
  }
  return colors.primary;
}
